export default __webpack_public_path__ + "static/media/cheque-bg.cfb88d19.webp";